import {type HeaderTag, useListViewTitle} from '../ListView/TitleContext'
import {HeaderTags} from '../constants'
import {useMemo} from 'react'

export function useNextHeaderTag(defaultValue: HeaderTag) {
  const {titleHeaderTag} = useListViewTitle()

  const titleTag = useMemo(() => {
    // https://github.com/github/issues/issues/7295#issuecomment-1679724969
    // We return h6 even if the preceeding title is h6 for screen reader users to quickly navigate via heading
    if (titleHeaderTag === 'h6') return 'h6'

    // The heading level is one level lower than the ListView's or ListGroup's heading level
    return HeaderTags.at(HeaderTags.indexOf(titleHeaderTag) + 1) ?? defaultValue
  }, [titleHeaderTag, defaultValue])

  return titleTag
}
